export default __webpack_public_path__ + "static/media/work-in-progress.200b5db7.png";